// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"727":"1d17e60c765a6025","1925":"1d17e60c765a6025","2888":"9784ff6027568984"}[chunkId] + ".css";
};